<template>
  <div class="cloudTrailWarningSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          v-model="alertRuleSearchKey"
          :placeholder="$t('alarms.common.filterByAlertRuleName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['logs:cloudTrail:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableCloudTrailWarning from "../cloudTrail_monitor/TableCloudTrailWarning";
var tableCloudTrailWarning = TableCloudTrailWarning;
export default {
  name: "CloudTrailWarningSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      alertRuleSearchKey: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("alertRuleSearchName", this.alertRuleSearchKey);
      tableCloudTrailWarning.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.cloudTrailWarningSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_monitor/CloudTrailWarningSearch.vue